import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getter'
import user from './modules/user'
import dict from './modules/dict'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    dict
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js